import './home.css'
import { useState,useEffect } from 'react'
import { getItens } from '../../../firebase/CRUD'
import AulaAdd from '../Aulas/AulaAdd'
import FichaAula from '../Aulas/FichaAula'
import { useAuth } from '../../../hooks/AuthContext'
import Button from '../../layout/Button/Button'
import { Plus } from 'lucide-react'
import GraficoAproveitamento from '../../layout/Dashboard/GraficoAproveitamento'
import Dashboard from '../../layout/Dashboard/Dashboard'

function Home(){
    const {usuario} = useAuth()
    const [Aulas,setAulas] = useState([])
    const [dataDashboard,setDataDashboard] = useState({
        presentes:0,
        matriculados:0,
    })
    const [cadastramento,setCadastramento] = useState(false)
    useEffect(()=>{
        const pegarAulas = (doc)=>{
            console.log(doc)
            setAulas(doc)
        }
    
    if(usuario)
        getItens("aulas",pegarAulas,usuario?.idEscola)
   
    },[usuario])

    const ativarCadastramento = ()=>{
        setCadastramento(true)
    }
    const desativarCadastramento = ()=>{
        setCadastramento(false)
    }
            
    return (
        <section className='home_container'>
            <h3>Bem vindo(a) {usuario?.nome}, ao seu app de registro de EBD</h3>
            {/* <GraficoAproveitamento presentes={dataDashboard.presentes} matriculados={dataDashboard.matriculados}/> */}
            {usuario?.perfil === 'adm' &&
             <Dashboard escolaId={usuario.idEscola}/>}
                <section>
                    <div>
                        <h2>Aulas</h2>
                    </div>
                    {usuario?.perfil === 'adm' &&
                        <div style={{display:"flex",width:"100%",justifyContent:"center", marginBottom:'10px'}}>
                        <Button icon={Plus} onClick={ativarCadastramento}>
                            Nova Aula
                        </Button>
                        </div>
                    }
                    <div className='home_list'>
                        {cadastramento && <AulaAdd cadastramento={desativarCadastramento}/>}
                        {Aulas.length === 0 
                            && <p>Carregando aulas</p>}
                        {Aulas.length > 0 && 
                            Aulas.map((item,id)=>
                                <FichaAula
                                    key={id}
                                    id={item.id}  
                                    licao={"Lição " + item.licao}
                                    presentes={item.presencas}
                                    biblia={item.biblia}
                                    data={item.dataAula}
                                    revista={item.revista}
                                    situacao={item.situacao}
                                    aproveitamento={item.aproveitamento
} 
                                />
                            )
                        }
                    </div>
                </section>
        </section>
    )
}

export default Home